export let Tag;

(function (Tag) {
  Tag["AppName"] = "app";
  Tag["Feature"] = "feature";
  Tag["UserType"] = "user_type";
  Tag["TransactionId"] = "transaction_id";
  Tag["PullRequest"] = "pr";
  Tag["Locale"] = "locale";
})(Tag || (Tag = {}));

export let SentryUserType;

(function (SentryUserType) {
  SentryUserType["Customer"] = "customer";
  SentryUserType["Guest"] = "guest";
})(SentryUserType || (SentryUserType = {}));

export let AppName;

(function (AppName) {
  AppName["Common"] = "common";
  AppName["Group"] = "group";
  AppName["Outpatient"] = "outpatient";
  AppName["App"] = "app";
  AppName["Clinic"] = "clinic";
  AppName["ProductShelf"] = "product-shelf";
  AppName["ProductComparison"] = "product-comparison";
  AppName["Quotation"] = "quotation";
  AppName["Recommendation"] = "recommendation";
  AppName["ClaimCalculator"] = "claim-calculator";
  AppName["Nav"] = "nav";
  AppName["Chatbot"] = "chatbot";
  AppName["AiSearch"] = "ai-search";
  AppName["DoctorList"] = "doctor-list";
  AppName["Voucher"] = "voucher";
})(AppName || (AppName = {}));